import { render } from "./representante-fatca.vue?vue&type=template&id=1d2e5372&scoped=true"
import script from "./representante-fatca.vue?vue&type=script&lang=js"
export * from "./representante-fatca.vue?vue&type=script&lang=js"

import "./representante-fatca.vue?vue&type=style&index=0&id=1d2e5372&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2e5372"]])

export default __exports__